import { ERROR_MSGS, CONSTANTS } from '../../utils/constants'
import { ERROR_CONSTANTS } from '../../store/actionTypes'
import { APP_HELPER } from '../../utils/helpers'

let bodyDirection
let errorMessage
let errorMessageDescription
let errorCodes = [
	CONSTANTS.HTTP_RESPONSE.INPROCESSIBLE,
	CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED,
	CONSTANTS.HTTP_RESPONSE.SERVER_ERROR,
	CONSTANTS.HTTP_RESPONSE.BAD_REQUEST,
]
const handleError = (error_response) => {
	const status = error_response?.status
	const description = error_response?.statusText
	const message = error_response?.data?.message
	const body = error_response?.data?.body
	if (errorCodes.includes(parseInt(status))) {
		return { type: ERROR_CONSTANTS.ERROR, status, message, description, body }
	} else {
		const error_message = error_response?.data?.message
		return { type: ERROR_CONSTANTS.MESSAGE, status, message: error_message, description, body }
	}
}

export const errorAction = (error_response) => {
	bodyDirection = APP_HELPER.APP_BODY_DIRECTION()
	const status = CONSTANTS.HTTP_RESPONSE.INPROCESSIBLE
	if (error_response === undefined) {
		const error_message =
			bodyDirection === CONSTANTS.LANG_DIRECTION.RTL
				? ERROR_MSGS.UR.NETWORK_CONNECTIVITY
				: ERROR_MSGS.EN.NETWORK_CONNECTIVITY
		return {
			type: ERROR_CONSTANTS.MESSAGE,
			status,
			message: error_message,
			description: {},
			body: {},
		}
	} else {
		return handleError(error_response)
	}
}

export const errorPageAction = (error_response) => {
	bodyDirection = APP_HELPER.APP_BODY_DIRECTION()

	if (error_response === undefined) {
		errorMessage =
			bodyDirection === CONSTANTS.LANG_DIRECTION.RTL
				? ERROR_MSGS.UR.NETWORK_CONNECTIVITY
				: ERROR_MSGS.EN.NETWORK_CONNECTIVITY
		errorMessageDescription =
			bodyDirection === CONSTANTS.LANG_DIRECTION.RTL
				? ERROR_MSGS.UR.NETWORK_CONNECTIVITY_DESCRIPTION
				: ERROR_MSGS.EN.NETWORK_CONNECTIVITY_DESCRIPTION

		return {
			type: ERROR_CONSTANTS.ERROR,
			status: ERROR_MSGS.EN.NETWORK_CONNECTIVITY_STATUS,
			message: errorMessage,
			description: errorMessageDescription,
		}
	} else {
		return handleError(error_response)
	}
}

export const successMsgAction = (success_response) => {
	const responseMessage = success_response?.data?.message
	return responseMessage
}
